/**
 * AdSense Ad Slot Configuration
 *
 * Configure your ad slot IDs here. Get these from your AdSense dashboard:
 * Ads → By ad unit → [Select ad unit] → Get code → data-ad-slot value
 *
 * Only include the numeric slot ID (e.g., "1234567890"), not the full "ca-pub-" prefix.
 * Leave empty string ("") to disable ads for that slot.
 */

export const adSlots = {
  // Homepage Ad Slots
  homepage: {
    leaderboard: "8414277294",
    inFeed: "9410566674",
  },

  // Weapon Builds Page Ad Slots
  weaponBuilds: {
    leaderboard: "8414277294",
    inFeed: "9410566674",
  },

  // Weapons Arsenal (roster) Page Ad Slots
  weapons: {
    leaderboard: "8414277294",
    inFeed: "9410566674",
  },

  // Attachments Hub Ad Slots
  attachments: {
    leaderboard: "8414277294",
    inFeed: "8350967572",
  },

  // Loadouts Page Ad Slots
  loadouts: {
    leaderboard: "8414277294",
    inFeed: "9410566674",
  },

  // Classes Hub + Class Detail Pages
  classes: {
    leaderboard: "8414277294",
  },

  // Individual Loadout/Weapon Pages
  detail: {
    leaderboard: "8414277294",
    // In-content units for long-form detail pages (mid + bottom).
    // ponytail: reusing the shared display slot so it fills today;
    // swap for a dedicated slot ID to get per-placement reporting (#6).
    inArticle: "9410566674",
  },
} as const;
